import devicemotionRelayTpl from '../templates/creative_preview/devicemotion_relay.directive.html';

export default function strDeviceMotionRelay() {
  return {
    restrict: 'E',
    template: devicemotionRelayTpl
  };
}
